import { useCallback, useState } from "react";
import RModal from "../../../components/Rsuite/Modal";
import { CustomButton } from "../../../components/CustomButton";
import RNavbar from "../../../components/Rsuite/Navbar";
import DadosBanner from "./Dados";
import HorariosBanner from "./Horarios";
import { useAuth } from "../../../hooks/auth";
import api from "../../../services/api";
import { toastSuccess, toastError } from "../../../toasts";

const EditarCadastrarBanner = ({ open, onClose, banner, setBanner, setBanners }) => {
  const [active, setActive] = useState('dados');
  const {id_empresa } = useAuth();
  const [descricao, setDescricao] = useState('');
  const [status, setStatus] = useState('0');
  const [imagemFile, setImagemFile] = useState(null);

  const handleSubmit = useCallback(async () => {
      const formData = new FormData();
      formData.append('IdEmpresa', id_empresa);
      formData.append('Descricao', descricao);
      if (imagemFile) {
        formData.append('Imagem', imagemFile);
      }

      if (banner) {
        formData.append('Ativo', status);
        await api.patch(`/banner/alterar/${banner.Id}`, formData)
        .then((res) => {
          setBanners((state) =>
            state.map((e) => {
              if (e.Id !== res.data.Id) {
                return e;
              }
              e = res.data;
              return e;
            }),
          );
          toastSuccess('Banner atualizado com sucesso.');
          onClose();
        })
        .catch((error) => {
          toastError('Não foi possivel atualizar o banner.');
          console.error("Erro ao atualizar banner:", error);
        });
      } else {
        await api.post('/banner/criar', formData)
        .then((res) => {
          setBanners(state => [...state, res.data]);
          toastSuccess('Banner salvo com sucesso.');
        })
        .catch((error) => {
          toastError('Não foi possivel salvar o banner.');
          console.error("Erro ao salvar banner:", error);
        });
      }
  },[banner, descricao, id_empresa, imagemFile, onClose, setBanners, status]);

  return (
    <RModal
      open={open}
      onClose={onClose}
      title={banner ? "Editar Banner" : "Cadastrar Banner"}
      size="md"
      footer={
        <>
          <CustomButton appearance="default" onClick={onClose}>
              Cancelar
          </CustomButton>
          <CustomButton onClick={handleSubmit}>Salvar</CustomButton>
        </>
      }
    >
      <RNavbar
        active={active}
        setActive={setActive}
        navItens={[
          {
            key: 'dados',
            name: 'Dados',
            disabled: false,
            hidden: false,
          },
          banner && {
            key: 'horarios',
            name: 'Horários',
            disabled: !banner,
            hidden: true,
          },
        ]}
      />
      {active === 'dados' &&
        <DadosBanner
          banner={banner}
          setBanner={setBanner}
          descricao={descricao}
          setDescricao={setDescricao}
          imagemFile={imagemFile}
          setImagemFile={setImagemFile}
          setStatus={setStatus}
        />}
      {active === 'horarios' && <HorariosBanner banner={banner} />}
    </RModal>
  )
}

export default EditarCadastrarBanner;
